/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';

// @types
import { ProfessionalInfo } from '../../../types/profile.types';
import useStatisticStore from '../../../store/useStatisticStore';

const ProfileView: React.FC<{
    professionalInfo: ProfessionalInfo | null,
    galleryCompany: { id: string, value: Blob }[],
    logo: string
}> = ({ professionalInfo, galleryCompany, logo }) => {
    const { t } = useTranslation();
    const { statistics, fetchStatistics } = useStatisticStore();

    const getImage = (id: string) => {
        const image = galleryCompany?.find((item: any) => item?.id === id);
        if (!image) return "";
        return URL.createObjectURL(image.value);
    }

    useEffect(() => {
        if (professionalInfo?.professionalId) {
            fetchStatistics(professionalInfo.professionalId ?? '');
        }
    }, [professionalInfo, fetchStatistics]);

    return (
        <div className='w-full min-h-[30vh] max-h-[40vh] lg:max-h-[75vh] flex flex-col gap-[50px] '>
            <div className='w-full flex flex-col lg:flex-row justify-center gap-[20px]'>
                <div className='w-full flex flex-col justify-center items-center gap-[20px]'>
                    <img
                        src={logo ? logo : '/assets/img/no-image.png'}
                        alt="Company logo"
                        className='w-[100px] h-[100px] rounded-full border'
                    />
                    <h5 className='flex text-[#444A6D] dark:text-white text-[18px] font-medium '>
                        {professionalInfo?.name}
                    </h5>

                    <div className="w-full flex justify-evenly gap-[10px]">
                        <div className="w-full flex flex-col justify-center items-center">
                            <p className='flex text-[#F97068] text-[20px] font-semibold'>
                                {statistics?.followers}
                            </p>
                            <p className='flex text-[#AAAAAA] dark:text-white text-[14px] font-medium'>
                                {t("professional.marketplace.followers")}
                            </p>
                        </div>
                        <div className="w-full flex flex-col justify-center items-center">
                            <p className='flex text-[#F97068] text-[20px] font-semibold'>
                                {statistics?.following ?? 0}
                            </p>
                            <p className='flex text-[#AAAAAA] dark:text-white text-[14px] font-medium'>
                                {t("requestsAndProposals.details.following")}
                            </p>
                        </div>
                        <div className="w-full flex flex-col justify-center items-center">
                            <p className='flex text-[#F97068] text-[20px] font-semibold'>
                                {statistics?.likes}
                            </p>
                            <p className='flex text-[#AAAAAA] dark:text-white text-[14px] font-medium'>
                                {t("professional.marketplace.likes")}
                            </p>
                        </div>
                    </div>
                </div>

                <div className='w-full flex flex-col gap-[10px]'>
                    <h5 className='w-full flex text-[#666666] dark:text-white text-[14px]'>
                        {t("requestsAndProposals.details.ourHistory")}
                    </h5>
                    <p className='w-full h-[160px] flex text-[#6A6A6A] dark:text-white/70 text-[13px] font-normal  leading-loose border border-[#6A6A6A] rounded-md p-[10px] max-h-[30vh] overflow-auto'>
                        {professionalInfo?.history}
                    </p>
                </div>
            </div>

            <div className='w-full h-[50vh] flex flex-col gap-[20px]'>
                <h6 className='w-full flex text-[#666666] dark:text-white text-[14px]'>
                    {t("requestsAndProposals.details.ourFacilities")}
                </h6>

                {galleryCompany?.length ?
                    <div className="w-full grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-[20px] flex-1">
                        {
                            galleryCompany?.map((image, index: number) => (
                                <div className='w-full col-spam-1' key={index}>
                                    <img
                                        src={getImage(image.id)}
                                        alt="Company logo"
                                        className='w-full h-[180px] xl:h-64 object-cover rounded-xl xl:rounded-3xl xl:p-1 '
                                    />
                                </div>
                            ))
                        }
                    </div>
                    : <div className='w-full flex text-[20px] text-gray-400 text-center justify-center mt-[40px]'>
                        {t("requestsAndProposals.details.noGallery")}
                    </div>
                }
            </div>
        </div>
    )
}

export default ProfileView